module.exports = __webpack_public_path__ + "static/AvenirLTStd-Light-0453698b6947a05e1e5a7bb2a2c1c0c1.woff";